// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ExpertCulinaryCategories_section__u-ivJ {
  max-width: 1200px;
  margin: 0 auto 3.5rem;
  padding: 0.5rem 1.25rem 0;
}

.ExpertCulinaryCategories_headerRow__Inl\\+t {
  display: flex;
  align-items: flex-end;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
  margin-bottom: 1.25rem;
}

.ExpertCulinaryCategories_title__dGbhw {
  margin: 0 0 0.35rem;
  font-size: clamp(1.35rem, 3vw, 1.75rem);
  font-weight: 700;
  color: #0a0a0a;
}

.ExpertCulinaryCategories_subtitle__960fK {
  margin: 0;
  font-size: 0.95rem;
  line-height: 1.55;
  color: #4a4a4a;
  max-width: 640px;
}

.ExpertCulinaryCategories_exploreLink__efL6K {
  display: inline-flex;
  align-items: center;
  gap: 0.35rem;
  color: #ff5c09;
  font-size: 0.875rem;
  font-weight: 600;
  text-decoration: none;
  white-space: nowrap;
  transition: opacity 0.2s ease;
}

.ExpertCulinaryCategories_exploreLink__efL6K:hover {
  opacity: 0.85;
  color: #ff5c09;
}

.ExpertCulinaryCategories_grid__Su818 {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1rem;
}

.ExpertCulinaryCategories_categoryCard__IZAPt {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  border-radius: 12px;
  padding: 1.25rem;
  text-decoration: none;
  color: inherit;
  transition: border-color 0.22s ease, box-shadow 0.22s ease, transform 0.15s ease;
}

.ExpertCulinaryCategories_categoryCard__IZAPt:hover {
  border-color: #ff5c09;
  box-shadow: 0 8px 22px rgba(255, 92, 9, 0.08);
  transform: translateY(-1px);
}

.ExpertCulinaryCategories_iconWrap__AhlRl {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: 10px;
  background: #fff4ed;
  color: #ff5c09;
}

.ExpertCulinaryCategories_cardTitle__wolFk {
  margin: 0;
  font-size: 1rem;
  font-weight: 700;
  color: #0a0a0a;
}

.ExpertCulinaryCategories_cardText__qdLEs {
  margin: 0;
  font-size: 0.85rem;
  line-height: 1.55;
  color: #4a4a4a;
}

@media (max-width: 991px) {
  .ExpertCulinaryCategories_grid__Su818 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (max-width: 640px) {
  .ExpertCulinaryCategories_headerRow__Inl\\+t {
    align-items: flex-start;
    flex-direction: column;
  }

  .ExpertCulinaryCategories_grid__Su818 {
    grid-template-columns: 1fr;
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Home/ExpertCulinaryCategories.module.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,SAAS;EACT,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,uCAAuC;EACvC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,gFAAgF;AAClF;;AAEA;EACE,qBAAqB;EACrB,6CAA6C;EAC7C,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE;IACE,gDAAgD;EAClD;AACF;;AAEA;EACE;IACE,uBAAuB;IACvB,sBAAsB;EACxB;;EAEA;IACE,0BAA0B;EAC5B;AACF","sourcesContent":[".section {\n  max-width: 1200px;\n  margin: 0 auto 3.5rem;\n  padding: 0.5rem 1.25rem 0;\n}\n\n.headerRow {\n  display: flex;\n  align-items: flex-end;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n  margin-bottom: 1.25rem;\n}\n\n.title {\n  margin: 0 0 0.35rem;\n  font-size: clamp(1.35rem, 3vw, 1.75rem);\n  font-weight: 700;\n  color: #0a0a0a;\n}\n\n.subtitle {\n  margin: 0;\n  font-size: 0.95rem;\n  line-height: 1.55;\n  color: #4a4a4a;\n  max-width: 640px;\n}\n\n.exploreLink {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.35rem;\n  color: #ff5c09;\n  font-size: 0.875rem;\n  font-weight: 600;\n  text-decoration: none;\n  white-space: nowrap;\n  transition: opacity 0.2s ease;\n}\n\n.exploreLink:hover {\n  opacity: 0.85;\n  color: #ff5c09;\n}\n\n.grid {\n  display: grid;\n  grid-template-columns: repeat(4, minmax(0, 1fr));\n  gap: 1rem;\n}\n\n.categoryCard {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n  background: #ffffff;\n  border: 1px solid #e5e5e5;\n  border-radius: 12px;\n  padding: 1.25rem;\n  text-decoration: none;\n  color: inherit;\n  transition: border-color 0.22s ease, box-shadow 0.22s ease, transform 0.15s ease;\n}\n\n.categoryCard:hover {\n  border-color: #ff5c09;\n  box-shadow: 0 8px 22px rgba(255, 92, 9, 0.08);\n  transform: translateY(-1px);\n}\n\n.iconWrap {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  height: 40px;\n  border-radius: 10px;\n  background: #fff4ed;\n  color: #ff5c09;\n}\n\n.cardTitle {\n  margin: 0;\n  font-size: 1rem;\n  font-weight: 700;\n  color: #0a0a0a;\n}\n\n.cardText {\n  margin: 0;\n  font-size: 0.85rem;\n  line-height: 1.55;\n  color: #4a4a4a;\n}\n\n@media (max-width: 991px) {\n  .grid {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n}\n\n@media (max-width: 640px) {\n  .headerRow {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n\n  .grid {\n    grid-template-columns: 1fr;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"section": `ExpertCulinaryCategories_section__u-ivJ`,
	"headerRow": `ExpertCulinaryCategories_headerRow__Inl+t`,
	"title": `ExpertCulinaryCategories_title__dGbhw`,
	"subtitle": `ExpertCulinaryCategories_subtitle__960fK`,
	"exploreLink": `ExpertCulinaryCategories_exploreLink__efL6K`,
	"grid": `ExpertCulinaryCategories_grid__Su818`,
	"categoryCard": `ExpertCulinaryCategories_categoryCard__IZAPt`,
	"iconWrap": `ExpertCulinaryCategories_iconWrap__AhlRl`,
	"cardTitle": `ExpertCulinaryCategories_cardTitle__wolFk`,
	"cardText": `ExpertCulinaryCategories_cardText__qdLEs`
};
export default ___CSS_LOADER_EXPORT___;
